import { Box, Typography, Link } from '@material-ui/core';
import { useFormik } from 'formik';
import { makeStyles } from '@material-ui/core/styles';
import RecieveNewsField from '../../../common/forms/fields/components/recieveNewsField';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import LocaleKeys from '../../../locales/keys';
import postMessage from '../../../utils/postMessage';
import { newsFieldLocation } from '../../../constants/checkout.constant';

const useStyles = makeStyles((theme) => ({
  'field__input--error': {
    borderColor: theme.palette.error.main,
    borderWidth: '2px',
  },
  nameContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: '5%',
  },
  subscriptionDisclaimText: {
    paddingRight: '15px',
    margin: '10px 0 30px 0',
  },
  nameControls: {
    padding: '0px',
  },
  linkText: {
    fontFamily: 'TitilliumWeb-Regular',
    fontSize: '17px',
    letterSpacing: '.2px',
    paddingLeft: '20px',
  },
}));

const PaymentTermsAndConditions = ({
  handleSave,
  formData,
  formName,
  privacyPolicyText,
  subscriptionDisclaimText,
}) => {
  const { t } = useTranslation();
  const classes = useStyles();
  const formik = useFormik({
    initialValues: { ...formData },
    enableReinitialize: true,
  });

  useEffect(() => {
    if (typeof formik.values.paymentTermsAndConditions !== 'boolean') {
      return;
    }
    handleSave({ name: formName, formik });
  }, [formik.values.paymentTermsAndConditions]);

  const publishEvent = (event, params) => {
    postMessage(event, params);
  };

  return (
    <Box>
      <Box className={classes.subscriptionDisclaimText}>
        <Typography
          className={`${classes.linkText} ${
            ``
            //customClasses && customClasses.titilliumFont
          }`}
        >
          <span>
            <span>
              {t(LocaleKeys.payment.orders.subscriptionDislaimerTextPrefix)}
            </span>
            <Link
              data-testid="terms-and-condition-link"
              className={`${classes.link} `}
              color="textPrimary"
              underline="none"
              onClick={() => {
                publishEvent('module.subscriptionTerms', {});
              }}
            >
              {t(LocaleKeys.payment.orders.subscriptionDislaimerTCLink)}
            </Link>
            <span>
              {t(LocaleKeys.payment.orders.subscriptionDislaimerTextSuffix)}
            </span>
          </span>
        </Typography>
      </Box>
      <Box>
        <Box
          className={`field field--title ${classes.nameControls}`}
          mt={5}
          mb={5}
        >
          <RecieveNewsField
            classes={classes}
            name={formName}
            form={formik}
            key={1}
            type={newsFieldLocation.Checkout}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default PaymentTermsAndConditions;
